module.exports = {
  home: '首页',
  services: '服务',
  xmal: '项目',
  aboutus: '关于安太克',
  antekbannertext: '安太克提供全球定制化一站式供应链服务',
  antekbannertext2: '更快速，更便捷，更放心!',
  aboutus2: '关于我们',
  antek: '安太克供应链管理(深圳)有限公司',
  antekcont: '安太克有限公司2009年成立于香港，是一家专注于半导体行业运输服务的物流企业。2015年以来, 以深圳总部为业务核心，辐射成都、重庆、上海、苏州、无锡、江阴、武汉、西安、天津、香港等城市及地区，为半导体客户提供内地---香港跨境运输、仓储配送、保税仓、国际航空运输等一站式物流服务。业务范围遍及欧洲、南美、东南亚等全球100多个国家和地区，为全球数百家企业提供专业优质的物流服务。',
  viewdetails: '了解更多',
  ourservices: '我们的服务',
  domestic: '国内/跨境运输',
  Shipmentagencyservicesbylandseaandair: '海陆空运输代理服务',
  Bondedlogisticservice: '保税物流服务',
  Supplychainservice: '供应链服务',
  Supplychain: '供应链',
  WarehouseService: '仓储服务',
  domesticcont: '通过自营+整合社会资源的方式，形成了全国范围内较完善的运输体系，并提供物流咨询服务，包含物流模式设计、物流布点规划、物流增值等服务。',
  Shipmentagencyservicesbylandseaandaircont: '空运服务, 海空联运/空铁联等，海运服务，海运服务包括整柜（FCL）进出口和散货拼柜（LCL）进出口运输，航线涵盖北美、南美、欧地、东南亚、印巴、非洲等。',
  Bondedlogisticservicecont: '国家自贸区/海关特殊监管区域/保税物流中心内出口复进口业务，保税项下所有物流配送及报关报检业务。',
  Supplychainservicecont: '以消费性供应链、供应链金融为核心，提供进/出口代理、增/退税、仓储、通关、物流、资金结算等一站式服务平台；',
  WarehouseServicecont: '仓储物流服务是安太克当前专注的业务范围之一。在香港和深圳均租有仓库，并依托公司信息化和平台，以及订制化的订单管理平台与WMS仓储管理平台，从传统的交易型物流服务 转变为全面参与客户订单管理链多节点一体化服务，并通过全球性的信息网络为提供普通、监管和保税多种仓储、报关与运输结合的港前综合服务。',
  Typicalcases: '经典案例',
  Typicalcasescont: '安太克历经数千家客户实践，汇聚众多实战行业经。',
  Whychooseus: '为什么选择我们的服务',
  TeamAdvantage: '团队优势',
  TeamAdvantage1: '多年跨境物流系统经验',
  TeamAdvantage2: '一对一客服支持',
  TeamAdvantage3: '24小时快速服务响应',
  ServicesAdvantage: '服务优势',
  ServicesAdvantage1: '13年行业管理经验',
  ServicesAdvantage2: '服务为客户',
  ServicesAdvantage3: '成就也来自于客户',
  Marketadvantage: '市场优势',
  Marketadvantage1: '顺应时代发展走势',
  Marketadvantage2: '行业领军企业的选择',
  Strategicadvantage: '战略优势',
  Strategicadvantage1: '整合优质企业服务商',
  Strategicadvantage2: '引入和开发更多切实',
  Strategicadvantage3: '解决企业需求服务',
  joinus: '加入我们',
  news: '新闻动态',
  contactus: '联系我们',
  chartership: '包船',
  charterplane: '空运包机',
  ChartedProject: '包机项目',
  CharteredFlightProject: '空运包机项目',
  ProjectBackground: '项目背景',
  Wecanprovideprofessional: '能为各类不同行业及领域提供所需的航空包机专业解决方案,助力您完成企业所需要解决的运输难题。',
  Thecharteredflight: '芝加哥---上海浦东空运包机，搭载超大尺寸仪器设备的货运包机，成功从美国芝加哥机场起飞，顺利降落杭州萧山国际机场，随后全程海关监管保温车转关至上海浦东国际机场。',
  Customers: '服务客户',
  CharteredShipProject: '包船项目',
  ProjectProblems: '项目难题',
  Allseasisaforeigncontractor: '承接国外海工服务承包商Allseas 国内大型吊机及钢结构建造项目的原材料及成品运输。原材料特殊钢板主要由上海到香港/漳州建造工厂，成品由漳州发往欧洲。',
  Wehaveshippedsome: '为全球排名全五的某著名花园工具制造商运输大型生产机器， 分别从天津，上海发运到东南亚。',
  Vietnamproject: '越南项目',
  Bonded: '保税',
  Logisticsservice: '物流服务',
  ServiceIntroduction: '服务介绍',
  Bondedlogisticsservice: '保税物流服务',
  Exportandreimport: '国家自贸区/海关特殊监管区域/保税物流中心内出口复进口业务，保税项下所有物流配送及报关报检业务',
  Consultingservicesforforeigntradeaffairs: '对外贸易事务咨询服务',
  Theconsultingservices: '涉及关务、物流、外汇、关税、单证、流程等相关政策法规及管理实务的专业咨询服务。',
  Warehousinglogisticsserviceisoneof: '仓储物流服务是安太克当前专注的业务范围之一。依托公司信息化和平台，以及订制化的订单管理平台与WMS仓储管理平台，从传统的交易型物流服务转变为全面参与客户订单管理链多节点一体化服务，并通过全球性的信息网络为提供普通、监管和保税多种仓储、报关与运输结合的港前综合服务，以及香港、国内运输配送服务，致力于为客户优化供应链管理。',
  Anteksupplychainhas: '安泰克供应链在香港、深圳、东莞和苏州拥有40000多平方米的自营和合作仓库，拥有丰富的货源和集装箱运输。',
  Theintroductionofwarehousing: '仓储/保税业务介绍',
  BondedWarehousesinChina: '国内保税仓库',
  Location: "仓库位置",
  Area: "面积",
  Staff: "人员",
  OperatingSystem: "操作系统",
  BondedLogisticsCenter: "深圳机场保税物流中心",
  constanttemperature: "12000m²恒温仓库 8669m²普通仓库",
  Cloudstoragemanagement: "云仓储管理平台WMS-max",
  ShenzhenQianhaiBayFreeTradeZone: '深圳前海湾保税区',
  DongguanShatinBondedLogisticsCenter: '东莞沙田保税物流中心',
  SuzhouComprehensiveBondedLogisticsCenter: '苏州综合保税物流中心',
  Serviceprocess: '服务流程',
  Anewtypeofwarehouseissetup: '在特殊监管区域内设立的一种新型的仓库形态，实现保税与非保税货物同仓存储、进口与出口同仓存储。进口与出口同仓调拨、小额交易与大宗贸易同仓交割、内贸与外贸同仓一体。',
  Takethecoreofconsumersupply: '以消费性供应链、供应链金融为核心，',
  itprovidesonestopservice: '提供进/出口代理、增/退税、仓储、通关、物流、资金结算等一站式服务平台；',
  Theconsultingservicesreferto: '涉及关务、物流、外汇、关税、单证、流程等相关政策法规及管理实务的专业咨询服务',
  Domestic: '国内',
  Crossbordertransportation: '跨境运输',
  Logisticsconsultingservices: '物流咨询服务',
  providinglogisticsmode: '提供物流模式设计、物流布点规划、物流增值等服务。',
  Throughselfsupportintegrationofsocialresources: '通过自营+整合社会资源的方式',
  ithasformedarelativelydeveloped: '形成了全国范围内较完善的运输体系，提供全国干线、支线、同城、零担、多式联运等服务，包括中港跨境运输；',
  Originalfactorybooking: '原厂booking',
  Agentconfirming: '代理商确认',
  Haulage: '拖车提货报关',
  Arrangeflights: '安排航班',
  PickupatSZAirport: '深圳机场提货',
  SortanddeliverinHK: '香港分拣派送',
  CrossborderTransportationExport: '跨境运输模式（出口）',
  CrossborderTransportationImport: '跨境运输（进口）',
  InternationalandDomestic: '国内、国外海陆空',
  servicesinsea: '运输代理服务',
  Airlogisticssolutions: '专业的空运物流解决方案',
  Airlogisticsincludeslargecargo: '空运物流包含大货、小货、重货或泡货，机场到机场、门到机场或门到门的运输，提供高效、快捷的服务，安太克更是土耳其航空、埃塞俄比亚航空、阿提哈德航空、国泰航空、阿联酋航空等多家航空公司的核心代理。',
  Internationalairservice: '国际空运业务',
  Customerfirst: '客户至上，一切为了客户。为客户提供"快捷、高效、及时、安全"的服务;同时，凭借极强的现场操作能力，及时处理各种现场突发事件。不管是大货或小货、重货或泡货、机场到机场、门到机场或门到门的运输，使每件货物都能准确安全及时的运送到目的港。',
  Atpresentourcompany: '目前我司已成为大韩航空公司（KE）、韩亚航空公司（OZ）、全日空航空公司（NH）、港龙航空公司（KA），中国国际航空公司（CA），长荣航空（BR），上海航空（FM），土耳其航空（TK）、俄罗斯航空（RU）、国泰航空（CX）、阿联酋航空（EK），印度捷特航空公司（9W）等多家航空公司的核心代理，并与知名的航空公司签订货量合同和舱位协议可保障全年舱位之需求无虞，稳定淡旺季之成本，能极大地保障客户之服务质量和其所预算之运费成本。',
  EuropeanAirTransport: '欧洲空派',
  Introduction: '产品简介',
  AnteksEuropeanAir: '安太克供应链欧洲空派是依托于我司与各个航空公司及航空联盟直接签订合约，并与欧美当地清关公司、快递公司强强联合后开通的空运专线门到门服务，一经推出就得到广大跨境电商卖家一致好评。',
  Advantages: '产品优势',
  Costeffectivepricethebestprice: '性价比高计费方式灵活，价格最优',
  Airfreightshippingisdirect: '专线直飞空加派专线直飞、最快5天妥投',
  DUUDDPandmultiple: 'DUU/DDP清关多种清关模式，按需选择',
  Builtinand: '产品属性可发内置、配套电池产品',
  Fixedshippingspace: '固定舱位固定每天傍晚舱位，次日凌晨到达',
  Valueaddedservices: '增值服务投保、转寄、退件安排',
  TheavailableFBA: '可寄FBA须在FBA界面下单',
  Providingallprocess: '轨迹查询运输过程提供全程网上查询服务',
  Airshippinglogisticssolutions: '专业的全程海运物流解决方案',
  Itincludesimportand: '包括整柜（FCL）进出口和散货拼柜（LCL）进出口运输，航线涵盖北美、南美、欧地、东南亚、印巴、非洲等。是马士基航运（MAERSK）、地中海航运（MSC）、东方海外（00CL）、中远海（COSCO）、阳明海运（YML）、美国总统轮船（APL）、现代海运（HYANDAI）、法国达飞（CMA）、万海船务（WANHAI）、长荣海运（EVERGREEN）、等10多家船公司的直接签约代理人，提供全球性的国际海运服务。',
  landtransportation: '陆地运输',
  Professionalabilityonthepier: '专业的码头处理能力',
  Cargotrackingatsea: '全程货物海上跟踪',
  Cargomanagement: '项目货物管理人员',
  Familiaritywithstandardsinallwalksoflife: '熟悉各行各业的标准',
  Railwaylogisticssolutions: '专业的铁路物流解决方案',
  CRexpress: '中欧班列',
  CHINARAILWAYExpress: '中欧班列（英文名称CHINARAILWAYExpress，缩写CRexpress）是由中国铁路总公司组织，按照固定车次、线路、班期和全程运行时刻开行，运行于中国与欧洲以及“一带一路”沿线国家间的集装箱等铁路国际联运列车，是深化我国与沿线国家经贸合作的重要载体和推进“一带一路”建设的重要抓手。',
  Ourcompanyhascreatedaseriesof: '为响应国家“一带一路”发展战略，迎合市场和客户的出货需求，我司打造了一系列的中欧 铁路整箱及拼箱进出口运输服务，可全国上门提货，可派送欧洲全境，可做DDU/DDP服务，经营由全国各大城市如武汉、重庆、苏州、郑州、长沙、合肥、成都、义乌等至欧洲全境的铁路运输服务。',
  Advantages2: '中欧班列优势',
  Costeffective: '高性价比',
  Costeffective2: '运输时间为海运的三分之一，运输价格是空运的四分之一。',
  Convenientcustomsdeclaration: '报关便捷',
  convenientcustomsdeclaration2: '报关便捷，电子数据报关，铁路班列驶出边境前完成报关。',
  Fixedfreighttrain: '固定班列',
  Fixedfreighttrain2: '中欧定点、定线路、 定车次、定时间  、定价格。',
  Customsclearanceteam: '清关团队',
  Customsclearanceteam2: '欧洲资深的清关团队。',
  Scopeofapplication: '适用范围',
  Scopeofapplication2: '配套跟内置电池可普货走。',
  Doortodoorservice: '上门提货',
  Doortodoorservice2: '可全国上门提货，可派送欧洲全境。',
  Mainlines: '核心路线',
  Chongqing: '重庆（渝新欧）',
  Destination: '目的地',
  Time: '时效',
  day: '天',
  week4: '四班/周',
  week2: '二班/周',
  week5: '五班/周',
  Duisburg: '杜伊斯堡',
  Sichuan: '四川（蓉欧）',
  PolandLodz: '波兰罗兹',
  Changsha: '长沙（湘欧线）',
  RussiaProject: '俄罗斯多式联运项目',
  RussiaProjectBackground: '安太克供应链管理（深圳）有限公司是一家专注于半导体行业的物流企业，为客户提供国内外多式联运服务。2019年，安太克正式一体化发展战略为具体代表一体化战略，品牌设置于深圳，当前已在天津、上海、广州、佛山、成都、厦门等城市设立分公司。',
  MainRoutes: '主要航线',
  MultimodalServices: '多式联运服务',
  ServiceDescription: '服务描述',
  RussiaServiceDescription: '我司提供全方位物流与供应链服务，涵盖多种运输方式整合的多式联运解决方案，满足客户不同需求。通过整合全球优质运力资源和供应链网络，为客户提供高效、便捷的物流服务。',
  InternationalAirTransport: '国际汽运与危险品运输',
  ProjectAdvantages: '项目优势',
  ServiceCases: '服务案例',
  companyprofile: '安太克公司简介',
  Foundedin: '安太克成立于2017年，专注于提供空运、海运、仓储、中欧班列、电商物流等服务，业务范围遍及欧洲、南美、东南亚等全球100多个国家和地区，为全球数百家企业提供专业优质的物流服务。',
  In2019: '2019年,为了更深入的参与到当前全球贸易物流体系及国际物联网的发展趋势中，为了更精深地为客户提供更全面、更系统的供应链一体化服务，公司进行了业务体系与运营模式的全面升级，成立了安太克供应链管理(深圳)有限公司。',
  Anteksupply: '2019年,安太克供应链管理(深圳)有限公司总部设在深圳，并以深圳为据点，积极拓展全球贸易物流业务高度发达的华南地区往来全球的货运市场，先后在上海、成都、佛山、广州、厦门、天津等主要城市设立了分公司。',
  Basedonthesupply: '基于遍布全国延伸海外的供应链仓配网络，依托自主知识产权的物流管理系统和供应链大数据应用平台KingKooData，以及融合人工智能(AI)和物联网（IOT）等智能科技的物流系统综合解决方案，安太克未来将践行“供应链+大数据+AIOT”的新物流核心战略，致力于成长为全球贸易物流产业集成服务商。',
  Ourcorestrengths: '我们的核心优势',
  Ourcorestrengths2: '除传统海、空、陆运货代服务以外，公司更为客户提供一站式的供应链集成解决方案。在欧美、中东和俄罗斯三个业务方向，公司拥有全行业最优解决方案。',
  serviceidea: '服务理念',
  serviceidea2: '以客户为中心，考虑客户需求，解决客户担忧与供应链的问题，释放客户烦恼。把客户问题作为我们的问题来解决，把客户利益作为我们的利益来考虑是我们的宗旨。',
  Integratedservice: '集成式服务',
  Integratedservice2: '开展一站式物流服务、倾听客户需求、激励内部团队、提供最佳物流解决方案、节约物流成本。公司拥有经验丰富的项目管理团队和完善的供应链管理体系，并得到当地交通、港口资源、海外联盟等全方位服务的支持。',
  Marketingresources: '市场营销资源',
  Marketingresources2: '市场营销资源',
  Ourvision: '我们的愿景',
  Bethemostgrowth: '做最具成长价值的物流产业系统集成商。',
  Bethemost: '做客户最可靠的海外合作伙伴。',
  Getthebest: '从最尊敬的客户群体里获得最佳口碑。',
  Anteksjob: '安太克的工作机会',
  Since2019: '自成立以来，我们已将业务拓展至全球各地，公司总部位于深圳，在多地设有办事处，并且我们的业务覆盖范围每天都在扩大。',
  VIEWJOBSAVALIABLE: '查看当前空缺岗位',
  Theenvironmentwe: '我们为员工打造的环境',
  Asayoungandfastgrowing: '作为一家年轻且快速发展的全球供应链公司，我们为您提供',
  lexibleworkinghours: '灵活的工作时间、可观的薪资，不定时的奖金，礼品以及福利丰厚、舒适得工作环境。',
  Personaldevelopment: '专业发展',
  Personaldevelopment2: '我们为您提供适合个人发展的工作方向、职责和项目自由度。我们会在必要时为您提供指导和职业规划。',
  Reasonablyhighsalaryinmarket: '具有市场竞争力的薪酬',
  Reasonablyhighsalaryinmarket2: '在我们快节奏的工作环境中，您不仅能获得富有挑战性的工作和令人兴奋的机会，还能获得有竞争力的薪酬。',
  Enrichyoursociallife: '丰富社交活动',
  Enrichyoursociallife2: '在安太克，我们的社交活动非常活跃。我们组织线上、线下活动，每周固定提供舒适纯手工按摩，按月组织体育运动和其他丰富活动。让您在工作中保持专注和充满动力！',
  Startyourjourneywithus: '与我们一起开始您的旅程',
  Justclickit: "只需点击一下，即有机会加入一家创新型物流公司。",
  Belowtoview: '在下方查看我们的职位空缺并成为一个安太克人！',
  salary: '薪资',
  Jobresponsibilities: '岗位职责',
  Deliverresume: '投递简历',
  Industryinformation: '行业资讯',
  Focusonthenewtrend:'聚焦安太克供应链新动向，发布最新新闻欢迎您的关注！',
  Scancodeandpay:'扫码关注安太克动态',
  ElectronicCigarette:'电子烟供应链',
  EngineeringProject:'工程项目物流',
  Semiconductor:'半导体全球物流供应链',
  Personalbelongings:'私人物品',
}
